var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#C6C2C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5867 12.5H19.4144V21.053C18.4134 20.0098 16.2955 17.8857 14.3267 16.4437C14.3267 16.4437 16.2573 19.6734 20.0023 23.6651C23.7483 19.6734 25.6779 16.4437 25.6779 16.4437C23.7065 17.8876 21.5861 20.0155 20.5867 21.0572V12.5ZM26.1636 22.3378V26.0885H13.8396V22.3378H12.5V26.9295C12.5 27.079 12.5629 27.2267 12.6714 27.3333C12.78 27.441 12.9229 27.5 13.0753 27.5H26.8625C27.0139 27.5 27.2276 27.441 27.339 27.3305C27.4428 27.2228 27.5031 27.0733 27.5031 26.9295V22.3378H26.1636Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download_file.d771f8984de812ff901c5a5bb69d4637.svg";
export { ForwardRef as ReactComponent };